import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {ApiService} from '../../services/api.service';
import {ErrorHelper} from '../../common/ErrorHelper';
import {NotifierService} from 'angular-notifier';

export interface StaticPack {
  status: string;
  fileName: string;
  lastModifiedDate: Date;
  lastPreprodPromoteDate: Date;
  lastProdPromoteDate: Date;
}


@Component({
  selector: 'app-status-static',
  templateUrl: './status-static.component.html',
  styleUrls: ['./status-static.component.css']
})
export class StatusStaticComponent implements OnInit, AfterViewInit {

  displayedColumns: string[] = ['status', 'lastModifiedDate', 'fileName', 'lastPreprodPromoteDate', 'lastProdPromoteDate'];
  dataSource: MatTableDataSource<StaticPack>;
  filterValues = {
    filename: '',
    fromDate: '',
    toDate: ''
  };
  filenameFilter = new FormControl();
  filterForm = new FormGroup({
    fromDate: new FormControl(),
    toDate: new FormControl(),
  });

  get fromDate(): Date {
    return this.filterForm.get('fromDate').value;
  }

  get toDate(): Date {
    return this.filterForm.get('toDate').value;
  }

  @ViewChild(MatSort) sort: MatSort;

  constructor(
    private apiService: ApiService,
    private notifierService: NotifierService
  ) {
    this.dataSource = new MatTableDataSource<StaticPack>();
  }

  ngOnInit(): void {
    this.loadDataAsync();
  }

  ngAfterViewInit(): void {
    this.filenameFilter.valueChanges
      .subscribe(name => {
        this.filterValues.filename = name;
        this.dataSource.filter = JSON.stringify(this.filterValues);
      });
    this.filterForm.controls.fromDate.valueChanges
      .subscribe(
        fromDate => {
          this.filterValues.fromDate = fromDate;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      );
    this.filterForm.controls.toDate.valueChanges
      .subscribe(
        toDate => {
          this.filterValues.toDate = toDate;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      );
  }

  async loadDataAsync(): Promise<any> {
    try {
      await this.loadData();
    } catch (error) {
      console.log(error);
    } finally {
      this.dataSource.sort = this.sort;
      this.dataSource.filterPredicate = (data: StaticPack, filter) => {
        const searchTerms = JSON.parse(filter);
        const fileNameFilter = data.fileName.toLowerCase().includes(searchTerms.filename.toLowerCase());
        const fromFilter = data.lastModifiedDate >= searchTerms.fromDate;
        const toFilter = data.lastModifiedDate <= searchTerms.toDate;
        if (this.fromDate && this.toDate) {
          return fromFilter && toFilter && fileNameFilter;
        } else if (this.fromDate) {
          return fromFilter && fileNameFilter;
        } else if (this.toDate) {
          return toFilter && fileNameFilter;
        }
        return fileNameFilter;
      };
    }
  }

  loadData(): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      return this.apiService.getAllUploadStaticFileInfo().toPromise().then(
        (data) => {
          const staticPacks = data;
          this.dataSource = new MatTableDataSource<StaticPack>(staticPacks);
          console.log('Fetched the static packs');
          resolve(true);
        },
        (error) => {
          const errorMessage = ErrorHelper.disectError('load static file info', error);
          this.notifierService.notify('error', errorMessage);
          resolve(false);
        });
    });
  }

  reset(): void {
    this.filenameFilter = new FormControl();
    this.filterForm = new FormGroup({
      fromDate: new FormControl(),
      toDate: new FormControl(),
    });

    this.filterValues.filename = '';
    this.filterValues.fromDate = '';
    this.filterValues.toDate = '';
    this.dataSource.filter = JSON.stringify(this.filterValues);
  }
}
